import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Box,
} from "@mui/material";
import React, { type ReactNode } from "react";
import { Field, FieldRenderProps } from "react-final-form";
import { FormFieldWrapperProps, FormFieldWrapper } from "./FormFieldWrapper";

const CheckboxWrapper = (
  props: FieldRenderProps<string | number, HTMLElement, string | number> & {
    errorId?: string;
    required?: boolean;
  },
) => {
  const {
    errorId,
    required,
    input: { checked, value, name, onChange, ...restInput },
  } = props;

  return (
    <Checkbox
      name={name}
      inputProps={{
        ...restInput,
        "aria-describedby": errorId,
        "aria-invalid": Boolean(errorId),
        "aria-required": required,
      }}
      onChange={onChange}
      checked={checked}
      value={value}
    />
  );
};

export interface CheckboxFormFieldProps
  extends Omit<FormFieldWrapperProps, "children"> {
  name: string;
  label: ReactNode;
  mustBeTrue?: boolean;
}

export const CheckboxFormField: React.FC<CheckboxFormFieldProps> = ({
  name,
  label,
  mustBeTrue,
  ...wrapperProps
}) => {
  const errorId = `${React.useId()}-error`;

  return (
    <FormFieldWrapper {...wrapperProps}>
      <Field
        name={name}
        type="checkbox"
        validate={(v) =>
          mustBeTrue && v !== true ? "This must be checked" : undefined
        }
        render={(props) => {
          const showError = Boolean(
            (props.meta.touched || props.meta.submitFailed) && props.meta.error,
          );
          return (
            <>
              <FormControlLabel
                control={
                  <FormGroup>
                    <CheckboxWrapper
                      {...props}
                      errorId={showError ? errorId : undefined}
                      required={mustBeTrue}
                    />
                  </FormGroup>
                }
                label={label}
              />
              {showError && (
                <Box p={1}>
                  <FormHelperText id={errorId} error>
                    {props.meta.error}
                  </FormHelperText>
                </Box>
              )}
            </>
          );
        }}
      />
    </FormFieldWrapper>
  );
};
